import { pagesReducer } from '@hellodarwin/app-contentful/lib/redux/pages.slice';
import {
  assistantConversationReducer,
  assistantMessageReducer,
  assistantReducer,
} from '@hellodarwin/app-features/lib/features/assistant/redux';
import { acceptedGrantsReducer } from '@hellodarwin/app-features/lib/features/program-candidates-data/redux/accepted-grants-slice';
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { aiIntegrationReducer } from '../features/api/slices/ai-integration-slice';
import { applicationDocumentsReducer } from '../features/api/slices/application-documents-slice';
import { assetsReducer } from '../features/api/slices/assets-slice';
import checkoutReducer from '../features/api/slices/checkout-slice';
import { companyDocumentTypesReducer } from '../features/api/slices/company-document-types-slice';
import { companyDocumentsReducer } from '../features/api/slices/company-documents-slice';
import { contextConversationsReducer } from '../features/api/slices/client-conversation-slice';
import { ginStepsReducer } from '../features/api/slices/gin-steps-slice';
import { globalReducer } from '../features/api/slices/global-slice';
import { googleDriveReducer } from '../features/api/slices/google-drive-slice';
import { grantProfilesReducer } from '../features/api/slices/grant-profiles-slice';
import { grantAlertHistoryReducer } from '../features/api/slices/grant-alert-history-slice';
import { grantNotificationsReducer } from '../features/api/slices/grants-notifications-slice';
import { grantsReducer } from '../features/api/slices/grants-slice';
import { matchesReducer } from '../features/api/slices/matches-slice';
import { profileReducer } from '../features/api/slices/profile-slice';
import { programReducer } from '../features/api/slices/programs-slice';
import { projectsReducer } from '../features/api/slices/projects-slice';
import providerListingReducer from '../features/api/slices/provider-listing-slice';
import { resourcesReducer } from '../features/api/slices/resources-slice';
import { reviewsReducer } from '../features/api/slices/reviews-slice';
import { rfpReducer } from '../features/api/slices/rfp-slice';
import { tagsReducer } from '../features/api/slices/tags-slice';
import { tagsV2Reducer } from '../features/api/slices/tags-slice-v2';
import { wonRfpReducer } from '../features/api/slices/won-rfp-slice';
import { fiUiReducer } from '../features/ui/funding-intelligence-ui-slice';
import onboardingReducer from '../modules/onboarding-flow/api/onboarding-slice';

export const store = configureStore({
  reducer: {
    global: globalReducer,
    grants: grantsReducer,
    grantNotifications: grantNotificationsReducer,
    grantAlertHistory: grantAlertHistoryReducer,
    grantProfiles: grantProfilesReducer,
    profile: profileReducer,
    program: programReducer,
    rfp: rfpReducer,
    wonRfp: wonRfpReducer,
    matches: matchesReducer,
    fiUi: fiUiReducer,
    resources: resourcesReducer,
    aiIntegration: aiIntegrationReducer,
    tags: tagsReducer,
    reviews: reviewsReducer,
    assets: assetsReducer,
    projects: projectsReducer,
    onboarding: onboardingReducer,
    tagsV2: tagsV2Reducer,
    assistant: assistantReducer,
    conversations: assistantConversationReducer,
    messages: assistantMessageReducer,
    checkout: checkoutReducer,
    applicationDocuments: applicationDocumentsReducer,
    companyDocumentTypes: companyDocumentTypesReducer,
    companyDocuments: companyDocumentsReducer,
    ginSteps: ginStepsReducer,
    googleDrive: googleDriveReducer,
    acceptedGrants: acceptedGrantsReducer,
    pages: pagesReducer,
    contextConversations: contextConversationsReducer,
    providerListing: providerListingReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
